import { ConsumerPortalContactUs } from "features/consumerPortalContactUs";

function ContactUsPage() {
  return <ConsumerPortalContactUs />;
}

export default ContactUsPage;
